module.exports = __webpack_public_path__ + "static/media/rating-4.c090b060.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rating-4.svg
// module id = 1093
// module chunks = 0